import i18n from 'scoreboard/components/i18n'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import YAxisRangeConfig from 'scoreboard/dashboards/widgets/chart/config/y-axis-range-config'
import appDisplay from 'scoreboard/components/app-display'

const EditAxesMenu = BootslideMenu.extend({

	/**
	 * @type ChartDesigner
	 */
	model: null,

	menu: function () {
		let options = []

		// X Axis Toggle
		options.push({
			type: 'toggle',
			label: 'charts.chart.xAxisLabels',
			contentView: BootslideMenu.ToggleProperty.extend({
				property: { label: 'charts.chart.xAxisLabels', name: 'xaxisLabels' }
			})
		})

		// Y Axis Toggle
		options.push({
			type: 'toggle',
			label: 'charts.chart.yAxisLabels',
			contentView: BootslideMenu.ToggleProperty.extend({
				property: { label: 'charts.chart.yAxisLabels', name: 'yaxisLabels' }
			})
		})

		// Y Axis Range Config
		options.push({
			label: 'charts.setYAxisRange',
			target: () => {
				var configView = new YAxisRangeConfig({
					// Give the config view a clone of the chart, so that if user
					// cancels changes, original chart won't be modified
					model: this.model.clone(),
					data: this.model.data
				})
				appDisplay.dialog(configView)

				configView.on('save', () => {
					configView.trigger('done')
					this.model.trigger('change')

					// Set the chart designer to the updated model
					this.model.set(configView.model.toJSON())
				})
			}
		})

		return {
			label: i18n.get('common.edit2', i18n.get('charts.axes')),
			target: options,
			width: 200
		}
	}
})

export default EditAxesMenu

EditAxesMenu.__filename__ = 'charts/edit/edit-axes-menu.js'
